"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderPrefixes = exports.DataSourceProvider = void 0;
var DataSourceProvider;
(function (DataSourceProvider) {
    DataSourceProvider[DataSourceProvider["Amazon"] = 1] = "Amazon";
    DataSourceProvider[DataSourceProvider["Google"] = 2] = "Google";
    DataSourceProvider[DataSourceProvider["SSH"] = 3] = "SSH";
    DataSourceProvider[DataSourceProvider["URL"] = 4] = "URL";
    DataSourceProvider[DataSourceProvider["GEO"] = 5] = "GEO";
    DataSourceProvider[DataSourceProvider["BaseSpace"] = 6] = "BaseSpace";
    DataSourceProvider[DataSourceProvider["RemoteStorage"] = 7] = "RemoteStorage";
})(DataSourceProvider || (exports.DataSourceProvider = DataSourceProvider = {}));
exports.ProviderPrefixes = [
    { provider: DataSourceProvider.Amazon, prefixes: ["s3://"] },
    { provider: DataSourceProvider.Google, prefixes: ["gs://"] },
    { provider: DataSourceProvider.SSH, prefixes: ["/"] },
    {
        provider: DataSourceProvider.URL,
        prefixes: ["http://", "https://", "ftp://", "ftps://"],
    },
    { provider: DataSourceProvider.RemoteStorage, prefixes: ["remote://"] },
];
